import React, {
    Component,
    Fragment,
} from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import store from '../../admin/store'
import toggleCheerFunc from '../../front/components/shared/toggle-cheer'
import { toggleCheer as simpleToggleCheer } from './helpers'
import Button from '../../front/components/shared/sn-button'
import SnIcon from '../../front/components/shared/sn-icon'
import Loader from '../../front/components/shared/loader'
import { i18n } from '../../validator'

const CheerIcon = '/images/cheer-dark.svg'

@i18n()
class CheerModalPop extends Component {
    toggleCheer = () => {
        store.dispatch({
            type: 'SET_CHEER_MODAL',
            force: true,
        })

        toggleCheerFunc(true, false)
            .then(() =>
                store.dispatch({
                    type: 'SET_CHEER_ENTITY',
                    entity: null,
                })
            )
    }

    /**
     * Called in case that this cheer modal has been called from event cheering
     * and it's purpose is to ask the user if he/she wants to cheer event's group
     * @return {*}
     */
    renderContentFromEvent = () => {
        const {
            cheer,
            busy,
        } = this.props

        return (
            <Fragment>
                <h3 className="w-100 text-center f4">
                    {cheer.entity && !busy && (
                        <Fragment>
                            Nyní fandíte události: {cheer.entity.name}
                        </Fragment>
                    )}
                    {!cheer.entity && !busy && (
                        cheer.modalText
                    )}
                    {busy && (
                        <Loader />
                    )}
                </h3>
                {!busy && cheer?.entity?.organisingGroup?.data?.images && (
                    <div className="d-flex w-100 text-center">
                        <img className="d-block mx-auto w-20 h-20 my-2"
                            src={cheer.entity.organisingGroup.data.images.logo}
                            alt="Logo - organizátora" />
                    </div>
                )}

                {!busy && cheer.entity && (
                    <Fragment>
                        <div className="text-center w-100 f4">
                            &#8212; chcete také &#8212;
                        </div>
                        <div className="text-center font-weight-bold w-100 pb-2 f3">
                            {cheer.modalText}
                        </div>
                    </Fragment>
                )}
            </Fragment>
        )
    }

    /**
     * This function is used in case of cheering from subgroup.
     * Different logic when cheering in modal from event and from group.
     * Standard cheering function is too complex for this case so I
     * created a simple toggle cheer function that just send a request
     * and returns response.
     *
     * @param {Object} group
     */
    toggleCheerFromGroup = group => {
        const userIsCheer = group.additionalInfo.data.userStatus.isCheering

        store.dispatch({
            type: 'TOGGLE_BUSY_CHEER',
        })

        simpleToggleCheer(group.id, 'groups', userIsCheer)
            .then(() => {
                store.dispatch({
                    type: 'TOGGLE_CHEERING_RECOMMENDED_GROUP',
                    id: group.id,
                })

                store.dispatch({
                    type: 'TOGGLE_BUSY_CHEER',
                })
            })
    }

    /**
     * Called in case that user cheered some subgroup.
     * If user cheered some subgroup, let's ask him nicely if he/she wants
     * to cheer some of the related groups
     *
     * @returns {*}
     */
    renderContentFromGroup = () => {
        const {
            cheer,
            busy,
            recommendedGroups,
        } = this.props

        return (
            <Fragment>
                <h3 className="w-100 text-center f4">
                    {cheer.entity && !busy && `Nyní fandíte skupině: ${cheer.entity.name}`}
                </h3>
                {cheer.entity.images && cheer.entity.images.logo && (
                    <div className="d-flex w-100 text-center">
                        <img
                            className="d-block mx-auto w-20 h-20 my-2"
                            src={cheer.entity.images.logo}
                            alt="Logo skupiny"
                        />
                    </div>
                )}
                <div className="text-center w-100 f4">
                    &#8212; chcete také &#8212;
                </div>
                <div className="text-center font-weight-bold w-100 pb-2 f3">
                    Fandit těmto skupinám?
                </div>
                {recommendedGroups && recommendedGroups.map(group => (
                    <div className="d-flex align-items-center justify-content-between" key={group.id}>
                        <div>
                            <img src={group.images.logo} className="u-circle__icon mr-4" alt=""/>
                            <span>{group.name}</span>
                        </div>
                        <Button
                            className="u-circle no-focus-outline"
                            onClick={() => this.toggleCheerFromGroup(group)}
                        >
                            <div className="u-circle__icon u-circle__icon--cheer">
                                {!busy && group.additionalInfo.data.userStatus.isCheering &&
                                    <SnIcon className="sn-cheer-circle-fill sn-lg text-color-brand"/>
                                }
                                {!busy && !group.additionalInfo.data.userStatus.isCheering &&
                                    <SnIcon
                                        isHoverable={true}
                                        className="sn-lg text-color-brand"
                                        notHoverClassName="sn-cheer-circle-empty"
                                        hoverClassName="sn-cheer-circle-fill"
                                    />
                                }
                                {busy &&
                                    <Loader className="u-circle__loader" />
                                }
                            </div>
                        </Button>
                    </div>
                ))}
            </Fragment>
        )
    }

    render = () => {
        const {
            cheer,
            busy,
            t,
        } = this.props

        if (!cheer.modalVisible) {
            return null
        }

        return (
            <div className="position-relative">
                <div className="Navbar-login__overlay" onClick={() => store.dispatch({ type: 'TOGGLE_CHEER_MODAL' })} />
                <div className="Navbar-login__modal-pop p-3 max-h-90vh overflow-y-auto">
                    <div
                        className={classnames({
                            'd-flex flex-column': true,
                            'align-items-end': !cheer.fromGroup,
                        })}
                    >
                        {cheer.fromGroup ?
                            this.renderContentFromGroup()
                            :
                            this.renderContentFromEvent()
                        }

                        {!busy && cheer.entity && !cheer.fromGroup && (
                            <div className="d-flex justify-content-between w-100">
                                <Button onClick={() => store.dispatch({ type: 'TOGGLE_CHEER_MODAL' })}
                                    className="btn btn-outline-color-gray-dark-3 btn-md mt-2 d-flex align-items-center"
                                >
                                    {t('cheerModal.notNow')}
                                </Button>
                                <Button
                                    onClick={this.toggleCheer}
                                    className="btn-md text-color-white mt-2 Event-detail__header__left-block-fan"
                                >
                                    <img src={CheerIcon} alt="Ikona - fandit" /> {t('cheerModal.primaryButtonText')}
                                </Button>
                            </div>
                        )}

                        {!busy && (!cheer.entity || cheer.fromGroup) && (
                            <Button onClick={() => store.dispatch({ type: 'TOGGLE_CHEER_MODAL' })}
                                className="btn btn-outline-color-gray-dark-3 btn-md mt-2 mx-auto"
                            >
                                {t('cheerModal.close')}
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(state => ({
    busy: state.app.cheer.busy,
    cheer: state.app.cheer,
    userIsCheer: state.app.cheer.isCheer,
    authedUser: state.auth.user,
    recommendedGroups: state.app.recommendedGroups,
}))(CheerModalPop)
